import {
  faFolders,
  faQuestionCircle,
  faPalette,
  faSliders,
  faSquarePollVertical,
  faUsers,
  faWallet,
  faCog,
  faShieldCheck,
  faUserAlt,
  faCalendarAlt,
  faMoneyBillWave,
  faHourglass,
  faFileInvoice,
  faCoins,
  faFileInvoiceDollar,
} from '@fortawesome/pro-light-svg-icons';

import { HELP, routes } from '~/constants';
import { NavigationConfig } from '../types';

export const config = {
  links: {
    myOrders: {
      title: 'My orders',
      to: routes.profile.orders,
      icon: faFolders,
    },
    myTeam: {
      title: 'My team',
      to: routes.profile.team,
      icon: faUsers,
    },

    billingOverview: {
      title: 'Billing details',
      to: routes.profile.billing.overview,
      icon: faMoneyBillWave,
      canShow: (user) => user?.customerRole === 'owner',
    },
    billingPaymentHistory: {
      title: 'Payment history',
      to: routes.profile.billing.payments_history,
      icon: faFileInvoice,
      canShow: (user) => user?.customerRole === 'owner',
    },
    billingCreditHistory: {
      title: 'Credit history',
      to: routes.profile.billing.credit_history,
      icon: faHourglass,
      // credit-expiration: It became unneeded right before release, but we may find a use for it in the future
      // canShow: (user) => user?.customerRole === 'owner',
      canShow: () => false,
    },
    billingCreditPacks: {
      title: 'Credit packs',
      to: routes.profile.billing.credits,
      icon: faCoins,
      // only regular, pro and techpack users are allowed to buy credit packs
      // I've created different variants to verify that pro and techpack has no daily capacity
      canShow: (user) => user?.customerRole === 'owner' && !user?.hasDailyCapacity,
    },
    billingSubscriptions: {
      title: 'My plan',
      to: routes.profile.billing.subscription,
      icon: faFileInvoiceDollar,
      canShow: (user) => user?.customerRole === 'owner',
    },

    needHelp: {
      title: 'Need help?',
      href: HELP,
      newTab: true,
      icon: faQuestionCircle,
    },
    customFields: {
      title: 'Custom fields',
      to: routes.profile.fields,
      icon: faSliders,
      canShow: (user) => Boolean(user?.supportsCustomFields),
    },

    userDetails: {
      title: 'User details',
      to: routes.profile.user_details,
      icon: faUserAlt,
    },
    security: {
      title: 'Security',
      to: routes.profile.security,
      icon: faShieldCheck,
    },
    capacityOverview: {
      title: 'Insights dashboard',
      to: routes.profile.capacity_overview,
      icon: faSquarePollVertical,
      canShow: (user) =>
        Boolean(user?.hasDailyCapacity && !user.hidePrices && user.customerRole !== 'manager'),
    },
    styleTemplates: {
      title: 'Style templates',
      to: routes.profile.style_templates,
      icon: faPalette,
      canShow: (user) => user?.customerRole === 'owner',
    },
    holidayCalendar: {
      title: 'Holiday calendar',
      to: routes.profile.holidays_calendar.index,
      icon: faCalendarAlt,
      isNew: true,
    },
  },
  subMenus: {
    settings: {
      icon: faCog,
      title: 'Settings',
    },
    billing: {
      icon: faWallet,
      title: 'Billing',
      // TODO change it as well so submenu can show for admins
      canShow: (user) => user?.customerRole === 'owner',
    },
  },
} satisfies NavigationConfig;
